class Toolbar extends HTMLElement {
    constructor() {
        super();
        this.setupEventListeners();
    }

    setupEventListeners() {
        // Attaching event listeners to all grid mode icons
        this.querySelectorAll('.icon-mode').forEach(icon => {
            icon.addEventListener('click', this.handleGridChange.bind(this));
        });
    }

    handleGridChange(event) {
        const target = event.currentTarget;
        const column = target.dataset.col;
        const collectionGrid = document.getElementById('CollectionProductGrid'); // Adjust this ID to your product grid container ID

        // Remove all grid classes first
        collectionGrid.classList.remove('grid-2', 'grid-3', 'grid-4', 'grid-5');
        // Add the selected grid class
        collectionGrid.classList.add(`grid-${column}`);

        // Update active state for icons
        this.querySelectorAll('.icon-mode').forEach(icon => {
            icon.classList.remove('active');
        });
        target.classList.add('active');
    }
}

customElements.define('toolbar-item', Toolbar);
